import { render, staticRenderFns } from "./VineyardSimpleGasMetricTable.vue?vue&type=template&id=7f8435ba&scoped=true&"
import script from "./VineyardSimpleGasMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardSimpleGasMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8435ba",
  null
  
)

export default component.exports